import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getNotificacionesUsuario, 
  updateNotificacionesUsuario 
} from "../../Services/notificaciones_service";

const initialState = {
  notificacionesUsuario: [],
  unreadCount: 0,
  timerRef: null,
  lastFetchTime: null,
  isLoading: false,
  error: null,
};

export const notificacionesUsuarioSlice = createSlice({
  name: "notificacionesUsuario",
  initialState,
  reducers: {
    setNotificacionesUsuario: (state, action) => {
      state.notificacionesUsuario = action.payload;
      state.lastFetchTime = Date.now();
    },
    setTimerRef: (state, action) => {
      state.timerRef = action.payload;
    },
    clearTimerRef: (state) => {
      if (state.timerRef) {
        clearTimeout(state.timerRef);
        state.timerRef = null;
      }
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    setUnreadCount: (state, action) => {
      state.unreadCount = action.payload;
    },
    resetUnreadCount: (state) => {
      state.unreadCount = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotificacionesUsuario.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchNotificacionesUsuario.fulfilled, (state, action) => {
        state.isLoading = false;
        state.notificacionesUsuario = action.payload || [];
        state.lastFetchTime = Date.now();
      })
      .addCase(fetchNotificacionesUsuario.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(markNotificacionesAsViewed.fulfilled, (state) => {
        state.notificacionesUsuario = state.notificacionesUsuario.map(
          (notificacion) => ({
            ...notificacion,
            snackbarMostrado: true,
          })
        );
      });
  },
});

export const fetchNotificacionesUsuario = createAsyncThunk(
  "notificacionesUsuario/fetchNotificacionesUsuario",
  async (idUsuario, { rejectWithValue }) => {
    try {
      if (!idUsuario) return [];
      const response = await getNotificacionesUsuario(idUsuario);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const markNotificacionesAsViewed = createAsyncThunk(
  "notificacionesUsuario/markNotificacionesAsViewed",
  async (notificacionesData, { rejectWithValue }) => {
    try {
      const response = await updateNotificacionesUsuario(notificacionesData);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const markNotificacionesAsRead = createAsyncThunk(
  "notificacionesUsuario/markNotificacionesAsRead",
  async (notificacionesData, { rejectWithValue }) => {
    try {
      const response = await updateNotificacionesUsuario(notificacionesData);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const {
  setNotificacionesUsuario,
  setTimerRef,
  clearTimerRef,
  setError,
  clearError,
  setUnreadCount,
  resetUnreadCount,
} = notificacionesUsuarioSlice.actions;

export default notificacionesUsuarioSlice.reducer;